export default {"src":"/_next/static/media/Sal.2f1de778.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};